import React, { useState, useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Media from "react-media";
import { DropDownButton } from "../../../../reusableComponents/dropDownButtonReusable/DropDownButton";
import { PopupInsideButton } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { ReusableOnboardingButton } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { Row } from "react-bootstrap";
import { Col } from "reactstrap";
import OrderingBufferTime, { CustomModal } from "../../../../vendorDashboardComponents/Orders/OrderRequest/OrderingBufferTime";
import { DropDownButtonMobile } from "../../../../reusableComponents/dropDownButtonReusable/DropDownButtonMobile";

export const OrderStatus = ({
  clickAction,
  status,
  onOpenModal,
  open,
  title,
  subtitle,
  onCloseModal,
  seatingStatus,
  onClickAll,
  onClickWalkin,
  onClickSeated,
  onClickNonSeated,
  showText,
  showTextTwo,
  displayText,
  onStatusClick,
  datatomap,
  pathnameData,
  orderStatus
}) => {
  const [state, setState] = useState({});

  useEffect(() => {
    datatomap.map((data, index) => {
      if (seatingStatus === data.id) {
        setState(data);
      }
    });
  }, [datatomap?.length, seatingStatus]);

  const [customModel, setCustomModal] = useState(false);
  const openCustomModel = () => setCustomModal(!customModel);

  const onSubmitCustom = (e) => {
    console.log({
      id: 7,
      title: "Custom",
      value: e?.max,
      clickActionProcessingTime: () => {},
    });

    clickAction({
      id: 7,
      title: "Custom",
      value: parseInt(e?.max),
      clickActionProcessingTime: () => {},
    });
    openCustomModel();
  };

  let allDashboard = pathnameData === "/orderdashboard/10" ? true : false;

  return (
    <React.Fragment>
      <Media query="(min-width:991px)">
      <DropDownButton
        dropDownCss="main-dropdown-section d-flex align-items-center justify-content-between cursor"
        headingText={title}
        orderText={true}
        // className=
        divClass="insidedropdownnew-div w-50"
        insideText={status}
        displayDropDown=""
        onClick={onOpenModal}
      />
      </Media>
      <Media query="(max-width:991px)">
        <DropDownButtonMobile
         dropDownCss=" buttonTypemobile main-dropdown-section d-flex align-items-center justify-content-between cursor p-3 rounded border"
         headingText={title}
         orderText={true}
         // className=
         divClass="insidedropdownnew-div d-flex "
         insideText={status}
         displayDropDown=""
         onClick={onOpenModal}
        //  extraStyles={{background:"black", color:"white"}}
        /> 



      </Media>

      {/* Custom Modal */}
      <Media query="(min-width:991px)">
      <CustomModal
        bigButtonProcessingHandler={onSubmitCustom}
        openCustomModel={openCustomModel}
        customModel={customModel}
      />
      </Media>
      <Media query="(max-width:991px)">
      <CustomModal
        bigButtonProcessingHandler={onSubmitCustom}
        openCustomModel={openCustomModel}
        customModel={customModel}
      />
      </Media>
      <Media query="(min-width:991px)">
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
        style={{ background: "black" }}
      >
        <div className="reusable-popup-header-newstyle">
          <h4 className="c-black font_24_b f12-400">{title}</h4>
        </div>
        <div className="super-admin-vendor-private-orders">
          <h4
            className="font_22_m  mb-5"
            style={{ marginTop: "10px", textAlign: "left" }}
          >
            {subtitle}
          </h4>
          <div className="container row justify-content-between super-admin-vendor-private-orders">
            <Row>
              {datatomap &&
                datatomap.map((data, index) => {
                  return (pathnameData === "/orderdashboard/20" &&
                    data.title === "All") ||
                    (pathnameData === "/orderdashboard/20" &&
                      data.title === "Completed") ||
                    (pathnameData === "/orderdashboard/20" &&
                      data.title === "Cancelled") ? (
                    <Col xs={6} key={index} className="mobile-p-0">
                      <PopupInsideButton
                        buttonClass={
                          state.id === data.id &&
                          state.orderType === data.orderType
                            ? "status-selected-button-box mobile-f16-400 sts_sld_btn_box_a text-center mr-0"
                            : "status-selected-button-box mobile-f16-400 text-center mr-0"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) =>
                          data?.title === "Custom"
                            ? openCustomModel()
                            : setState(data)
                        }
                      />
                    </Col>
                  ) : pathnameData !== "/orderdashboard/20" &&
                    data.title !== "Cancelled" ? (
                    <Col xs={6} key={index} className="mobile-p-0">
                      <PopupInsideButton
                        buttonClass={
                          state.id === data.id &&
                          state.orderType === data.orderType
                            ? "status-selected-button-box mobile-f16-400 sts_sld_btn_box_a text-center mr-0"
                            : "status-selected-button-box mobile-f16-400 text-center mr-0"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) =>
                          data?.title === "Custom"
                            ? openCustomModel()
                            : setState(data)
                        }
                      />
                    </Col>
                  ) : (
                    <></>
                  );
                })}
            </Row>
          </div>
          <div className="mt-5 d-flex">
            <ReusableOnboardingButton
              buttonTitle="Cancel Button"
              buttonClass={
                "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              }
              buttonText="Cancel"
              onClick={onCloseModal}
              buttonType="button"
            />
            <ReusableOnboardingButton
              buttonTitle="Confirm Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              buttonText="Confirm"
              onClick={() => clickAction(state)}
              buttonType="button"
            />
          </div>
        </div>
      </Modal>
      </Media>

      <Media query="(max-width:991px)">
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          modal: "small-popup",
          closeButton: "customCloseButton",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
        style={{ background: "black" }}
      >
        <div className="reusable-popup-header-newstyle">
          <h4 className="c-black font_24_b f12-400">{title}</h4>
        </div>
        <div className="super-admin-vendor-private-orders">
          <h4
            className="font_22_m  mb-5"
            style={{ marginTop: "10px", textAlign: "left" }}
          >
            {subtitle}
          </h4>
          <div className="container row justify-content-between super-admin-vendor-private-orders">
            <Row>
              {datatomap &&
                datatomap.map((data, index) => {
                  return (pathnameData === "/orderdashboard/20" &&
                    data.title === "All") ||
                    (pathnameData === "/orderdashboard/20" &&
                      data.title === "Completed") ||
                    (pathnameData === "/orderdashboard/20" &&
                      data.title === "Cancelled") ? (
                    <Col key={index} className="mobile-p-0 mr-2 ml-2">
                      <PopupInsideButton
                        buttonClass={
                          state.id === data.id &&
                          state.orderType === data.orderType
                            ? "status-selected-button-box mobile-f16-400 sts_sld_btn_box_a text-center mr-0"
                            : "status-selected-button-box mobile-f16-400 text-center mr-0"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) =>
                          data?.title === "Custom"
                            ? openCustomModel()
                            : setState(data)
                        }
                      />
                    </Col>
                  ) : pathnameData !== "/orderdashboard/20" &&
                    data.title !== "Cancelled" ? (
                    <Col key={index} className="mobile-p-0 mr-2 ml-2">
                      <PopupInsideButton
                        buttonClass={
                          state.id === data.id &&
                          state.orderType === data.orderType
                            ? "status-selected-button-box mobile-f16-400 sts_sld_btn_box_a text-center mr-0"
                            : "status-selected-button-box mobile-f16-400 text-center mr-0"
                        }
                        buttonText={data.title}
                        buttonType="button"
                        onClick={(e) =>
                          data?.title === "Custom"
                            ? openCustomModel()
                            : setState(data)
                        }
                      />
                    </Col>
                  ) : (
                    <></>
                  );
                })}
            </Row>
          </div>
          <div className="mt-5 d-flex">
            <ReusableOnboardingButton
              buttonTitle="Cancel Button"
              buttonClass={
                "onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              }
              buttonText="Cancel"
              onClick={onCloseModal}
              buttonType="button"
              style={{maxHeight:"40px"}}
            />
            <ReusableOnboardingButton
              buttonTitle="Confirm Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              buttonText="Confirm"
              onClick={() => clickAction(state)}
              buttonType="button"
              style={{maxHeight:"40px"}}
            />
          </div>
        </div>
      </Modal>
      </Media>
    </React.Fragment>
  );
};
